<template>
<div>
  <jobseeker-form :resumeTitle="false" />
</div>
</template>

<script>
import JobseekerForm from '@/components/jobseekers/jobseeker-form'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    JobseekerForm
  },
  computed: {
    ...mapState('jobseekerProfiles', [
      'jobseekerProfile'
    ])
  },
  methods: {
    ...mapActions('jobseekerProfiles', [
      'getJobseekerProfile'
    ]),
    ...mapActions('jobseekerForm', [
      'loadWithProfile'
    ])
  },
  async mounted () {
    // await this.getJobseekerProfile()
    // this.loadWithProfile(this.jobseekerProfile)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/edit-jobseeker.vue